const logoutUser = async () => {
  const storage = window.localStorage;
  storage.removeItem('access-token');
  storage.removeItem('user-id');
  storage.removeItem('organisation-id');
  storage.removeItem('x-app-package-name');
  storage.removeItem('x-app-type');
  storage.removeItem('x-app-version');
  storage.removeItem('isFetchedSettings');
  storage.removeItem('currencySymbol');
  storage.removeItem('workflow-base-url');
  storage.removeItem('finance-base-url');
  storage.removeItem('tracking-id');
  storage.removeItem('forward-reference-number');
  storage.removeItem('forward-item-description');
  storage.removeItem('base-url');
  storage.removeItem('consignment-reference-number');
  storage.removeItem('piece-reference-number');
  storage.removeItem('organisation-pretty-name');
  storage.removeItem('number-of-images');
  storage.removeItem('customer-support-config');
  storage.removeItem('selected-piece-data');
  storage.removeItem('session-id');

  window.location.href = '/session-expired';
};

const getBaseUrl = () => {
  const storage = window.localStorage;
  const baseUrl = storage.getItem('base-url');

  return baseUrl || '';
};

const getAuthenticationHeaders = () => {
  const storage = window.localStorage;

  const organisationId = storage.getItem('organisation-id');
  const token = storage.getItem('access-token');
  const userId = storage.getItem('user-id');
  const xAppPackageName = storage.getItem('x-app-package-name');
  const xAppType = storage.getItem('x-app-type');
  const xAppVersion = storage.getItem('x-app-version');
  const riderLat = storage.getItem('x-location-lat');
  const riderLng = storage.getItem('x-location-lng');


  return {
    'user-id': userId || '',
    'organisation-id': organisationId || '',
    'access-token': token || '',
    'x-app-type': xAppType || 'android',
    'x-app-package-name': xAppPackageName || 'com.shipsy.riderapp.demo',
    'x-app-version': xAppVersion || '465',
    'x-location-lat': riderLat || '',
    'x-location-lng': riderLng || '',
  };
};

const isUserLoggedIn = (): boolean => {
  const accessToken = window.localStorage.getItem('access-token');
  return !!accessToken;
};

const getErrorMessage = (err: any) => {
  if (!err.response) {
    return err.message || 'Network error or no response from server';
  }

  const status = err.response.status;
  const data = err.response.data || {};

  const serverErr = data.errorMessage ?? data.error;
  const serverMsg =
    typeof serverErr === 'string'
      ? serverErr
      : serverErr?.message;

  if (status === 500 && !serverMsg) {
    return 'Oops! A server error occurred. Please try again later.';
  }

  return serverMsg || `Request failed with status ${status}`;
};

const assessmentHeaders = () => {
  const storage = window.localStorage;
  const userId = storage.getItem('user-id');
  const token = storage.getItem('access-token');
  const organisationId = storage.getItem('organisation-id');
  return {
    'organisation-id': organisationId,
    'access-token': token,
    'id': userId,
  };



};

const assessmentRiderHeaders = () => {
  const storage = window.localStorage;
  const organisationId = storage.getItem('organisation-id');
  const token = storage.getItem('access-token');
  const userId = storage.getItem('user-id');
  const xAppPackageName = storage.getItem('x-app-package-name');
  const xAppType = storage.getItem('x-app-type');
  const xAppVersion = storage.getItem('x-app-version');

  return {
    'access-token': token,
    'organisation-id': organisationId,
    'user-id': userId,
    'x-app-package-name': xAppPackageName,
    'x-app-type': xAppType,
    'x-app-version': xAppVersion,
  };
};
const workflowBaseURl = () => {
  return window.localStorage.getItem('workflow-base-url') || '';
};

const financeBaseUrl = () => {
  const storage = window.localStorage;
  const baseUrl = storage.getItem('finance-base-url');

  return baseUrl || '';
};

const setAuthHeadersFromKey = (): void => {
  const queryParams = new URLSearchParams(window.location.search);
  const key = queryParams.get('key');

  // When the native app launches the webview with a `?key=...` handoff, that
  // key is the authoritative fresh credential — apply it even if localStorage
  // still has a stale token from a prior session, otherwise the first call
  // 401s on the old token and only succeeds on retry after the interceptor
  // clears storage.
  if (key) {
    try {
      const decryptedKey = atob(key);
      const parsedKey = JSON.parse(decryptedKey);

      Object.entries(parsedKey).forEach(([itemKey, value]) => {
        window.localStorage.setItem(itemKey, String(value));
      });
      return;
    } catch (e) {
      throw new Error('Invalid key. Your session may have expired.');
    }
  }

  if (isUserLoggedIn()) {
    return;
  }
  throw new Error('Please log in first.');
};

export { 
  logoutUser, getAuthenticationHeaders, isUserLoggedIn, getErrorMessage, assessmentHeaders, assessmentRiderHeaders, getBaseUrl, workflowBaseURl,
  financeBaseUrl, setAuthHeadersFromKey,
};
